import { Card, List, Modal, Tag } from "antd";
import { Typography } from "antd";
import { Title } from "../styles";
import { descricaoNiveis } from "../constants/descricaoNiveis";

const { Paragraph, Text } = Typography;

interface ModalDescricaoNiveisProps {
  isModalOpen: boolean;
  handleFechar: () => void;
}

export default function ModalDescricaoNiveis({
  isModalOpen,
  handleFechar,
}: ModalDescricaoNiveisProps) {
  const itens = Object.entries(descricaoNiveis)
    .map(([nivel, descricao]) => ({
      nivel: Number(nivel),
      descricao,
    }))
    .sort((a, b) => a.nivel - b.nivel);

  return (
    <Modal open={isModalOpen} onCancel={handleFechar} footer={null} width={720}>
      <Card
        title={<Title>Descrição dos níveis</Title>}
        style={{
          width: "100%",
          marginTop: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Paragraph>
          <Text strong>Resumo:</Text>
        </Paragraph>
        <Paragraph style={{ marginBottom: 8 }}>
          <Text strong>Datas exatas:</Text> check-in e check-out batem exatamente.
        </Paragraph>
        <Paragraph style={{ marginBottom: 8 }}>
          <Text strong>Datas aproximadas:</Text> um período contém o outro por completo, ou seja, atende integralmente mesmo sem datas idênticas. Exemplo: a procura é por um mês intero e a disponibilidade é de uma semana dentro desse mês, ou a procura é por um período de uma semana e a disponibilidade é de alguns dias dentro dessa semana.
        </Paragraph>
        <Paragraph style={{ marginBottom: 8 }}>
          <Text strong>Datas menos aproximadas:</Text> existe só uma sobreposição parcial do período. Exemplo: Procura é 01/01 a 08/01 e a disponibilidade é 05/01 a 10/01, ou a procura é 01/01 a 08/01 e a disponibilidade é 28/12 a 03/01.
        </Paragraph>
        <Paragraph style={{ marginBottom: 8 }}>
          <Text strong>Interesse não definido:</Text> o disponível não marcou claramente alugar nem trocar.
        </Paragraph>
        <Paragraph style={{ marginBottom: 16 }}>
          <Text strong>Interesse invertido:</Text> a procura é alugar e o disponível está como trocar, ou o contrário.
        </Paragraph>
        <List
          dataSource={itens}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={<Tag color="blue">Nível {item.nivel}</Tag>}
                description={item.descricao}
              />
            </List.Item>
          )}
        />
      </Card>
    </Modal>
  );
}
